export default "__VITE_ASSET__5893a7e2__"